import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../layout/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import store from '@/store'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '主页',
    component: HomeView,
    redirect : '/index',
    children:[
      {
        path:'/index',
        name:'首页',
        component: ()=>import('../views/HomeIndex.vue')
      },
      {
        path : '/sys/user',
        name : '用户管理',
        component: ()=>import('../views/sys/user/userIndex.vue')
      },
      {
        path : '/sys/role',
        name : '角色管理',
        component: ()=>import('../views/sys/role/roleIndex.vue')
      },
      {
        path : '/sys/menu',
        name : '菜单管理',
        component: ()=>import('../views/sys/menu/menuIndex.vue')
      },
      {
        path : '/bsns/Department',
        name : '道具管理',
        component: ()=>import('../views/bsns/Department/departmentIndex.vue')
      },
      {
        path : '/bsns/Post',
        name : '服装管理',
        component: ()=>import('../views/bsns/Post/postIndex.vue')
      },
      {
        path : '/userCenter',
        name : '个人中心',
        component: ()=>import('../views/userCener/userCenterIndex.vue')
      },
      {
        path : '/bsns/address',
        name : '地址管理',
        component: ()=>import('../views/bsns/Address/index.vue')
      },
      {
        path : '/bsns/sport',
        name : '运动记录',
        component: ()=>import('../views/bsns/Sport/index.vue')
      },
      {
        path : '/bsns/partner',
        name : '伴侣管理',
        component: ()=>import('../views/bsns/Partner/index.vue')
      },
      {
        path : '/bsns/category',
        name : '类别管理',
        component: ()=>import('../views/bsns/Category/index.vue')
      },
      {
        path : '/bsns/deletions',
        name : '注销管理',
        component: ()=>import('../views/bsns/Deletions/index.vue')
      },
    ]
  },
  {
    path:'/login',
    name:'登录',
    component: LoginView
  } 

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const originalPush = VueRouter.prototype.push
   VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}


router.beforeEach((to, from, next) => {
  if (to.path) {
    if (to.name != null){
      if ( to.path != '/login') {
        store.commit('ADD_TABS',to)
      }
      next()
    }else{
      next('/')
    }

  }else{
    next();
  }
});

export default router
